import styled from 'styled-components';

const StyledDarkModeSwitch = styled.button`
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.primary} !important;
  color: ${(props) => props.theme.colors.text.primary};
  border: 1px solid ${(props) => props.theme.colors.secondary};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  min-height: 40px;
  min-width: 40px;
  font-family: 'Material Icons Outlined' !important;
  font-size: 20px;
  font-weight: 300 !important;
`;

export { StyledDarkModeSwitch };
